import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Experience } from '../../core/models';
import { EsperienzeListConfig, AuthService, WMAIApiService, AppInformationService } from '../../core';
import { WgisService } from '../../wgis/wgis.service';
import { WGisDisplayMode } from '../../wgis/wgis.utils';
import { SuiModalService, ModalSize } from 'ng2-semantic-ui';
import { ConfirmModal, SimpleModal } from 'src/app/core/templates';
import { Angulartics2 } from 'angulartics2';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import * as foo from '../../core/models/functions-cordova';

@Component({
  selector: 'app-esperienza-admin-search',
  templateUrl: './esperienza-admin-search.component.html'
})

export class EsperienzaAdminSearchComponent implements OnInit {

  isMapVisible = false;
  isSmallScreen: boolean = false;
  isMobile: boolean = false;

  searchForm: FormGroup;
  destination: string;
  username: string = "";
  fromDate: Date;
  toDate: Date;
  type: string = "wait";

  filtersVisible = true;
  resultsVisible = true;

  bbox: string = "";

  results: Experience[] = [];
  resultsCount: number;
  loading = false;
  currentPage = 1;
  limit: number = 6;
  totalPages: Array<number> = [1];
  wait: number = 0;
  private: number = 0;
  public: number = 0;
  deleted: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private activedRoute: ActivatedRoute,
    private wgisservice: WgisService,
    private authservice: AuthService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private modalService: SuiModalService,
    private angulartics2: Angulartics2,
    private translateService: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private appService: AppInformationService,
    private zone: NgZone
  ) {
    this.isMobile = this.appService.iAmMobile();
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');

    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });

    this.wmaiservice.queryCountExperiencesPrivate(this.username).subscribe(data => {
      this.private = data[0].count;
    });
    this.wmaiservice.queryCountExperiencesDelete(this.username).subscribe(data => {
      this.deleted = data[0].count;
    });
    this.wmaiservice.queryCountExperiencesPublic(this.username).subscribe(data => {
      this.public = data[0].count;
    });
    this.wmaiservice.queryCountExperiencesWait(this.username).subscribe(data => {
      this.wait = data[0].count;
    });

    this.angulartics2.eventTrack.next({
      action: 'search',
      properties: { label: 'EsperienzaAdminSearchFormSearch' },
    });

    this.angulartics2.eventTrack.next({
      action: 'reset',
      properties: { label: 'EsperienzaAdminSearchFormReset' },
    });

    this.angulartics2.eventTrack.next({
      action: 'setPageTo',
      properties: { label: 'EsperienzaAdminSearchPagination' },
    });

    this.angulartics2.eventTrack.next({
      action: 'displaymap',
      properties: { label: 'EsperienzaAdminSearchShowMap' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showMap',
      properties: { label: 'EsperienzaAdminSearchShowMap' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showFilters',
      properties: { label: 'EsperienzaAdminSearchShowFilters' },
    });

    this.angulartics2.eventTrack.next({
      action: 'showResults',
      properties: { label: 'EsperienzaAdminSearchShowResults' },
    });

    this.angulartics2.eventTrack.next({
      action: 'export',
      properties: { label: 'EsperienzaAdminSearchExport' },
    });
  }

  ngOnInit() {
    this.isMapVisible = this.wgisservice.getMapVisible();
    window.scrollTo(0, 0)
    this.searchForm = this.createSearchForm();
    this.search();
  }

  reset() {
    this.searchForm.reset();
    this.router.navigate([], { replaceUrl: true });
  }
  /**
   * si ottiene la lista dell' espeprienze
   */
  search() {
    this.loading = true;
    this.currentPage = 1;
    this.totalPages = [1];
    this.getListaEsperienze();
  }

  setPageTo(pagenumber) {
    this.currentPage = pagenumber;
    this.getListaEsperienze();
  }

  showFilters() {
    this.filtersVisible = !this.filtersVisible;
    if (this.filtersVisible) {
      this.isMapVisible = false;
      this.resultsVisible = false;
    }
  }

  showMap() {
    // if (this.isMapVisible) {
    //   this.filtersVisible = false;
    //   this.resultsVisible = false;
    // }
  }

  showResults() {
    this.resultsVisible = !this.resultsVisible;
    if (this.resultsVisible) {
      this.filtersVisible = false;
      this.isMapVisible = false;
    }
  }
  /**
   * si crea il form di ricerca
   */
  private createSearchForm() {
    return this.formBuilder.group({
      destinazione: new FormControl(this.destination, { validators: [Validators.required, Validators.maxLength(50)] }),
      username: new FormControl(this.username, { validators: [Validators.required, Validators.maxLength(50)] }),
      type: new FormControl(this.type),
      fromDate: [''],
      toDate: ['']
    });
  }
  /**
   * si chiede la lista dell'esperienze prendendo la lingua di default e costruendo una tabella con i dati innessi
   */
  private getListaEsperienze() {
    this.results = [];
    this.wgisservice.clearSelection();
    let query: EsperienzeListConfig = {
      type: 'all',
      filters: {}
    };

    query.filters.limit = this.limit;
    query.filters.pageSize = this.limit;
    query.filters.pageNumber = this.currentPage;
    query.filters.locale = "\"" + this.translateService.getDefaultLang() + "\"";

    if (this.searchForm.controls["destinazione"].value != "" && this.searchForm.controls["destinazione"].value != null)
      query.filters.fulltext = this.searchForm.controls["destinazione"].value;


    if (this.searchForm.controls["type"].value != "" && this.searchForm.controls["type"].value != null)
      query.filters.type = this.searchForm.controls["type"].value;
    else
      query.filters.type = "wait";

    if (this.searchForm.controls["username"].value != "" && this.searchForm.controls["username"].value != null)
      query.filters.username = this.searchForm.controls["username"].value;

    this.loading = true;
    this.wmaiservice.queryAdminExperiences(query).subscribe(
      data => {
        if (data != null) {
          this.results.push(...data['data']);

          if (data['metadata']['rowCount'] != null) {
            this.resultsCount = data['metadata']['rowCount'];
            let tmp = Math.ceil(this.resultsCount / this.limit);
            this.totalPages = this.resultsCount <= 6 ? this.totalPages : Array.from(new Array<number>(tmp).keys()).map(x => ++x);
          }
        }
      });
    this.loading = false;
  }

  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
  /**
   * si esportano le esperienze tramite file
   */
  exportExperience() {
    let title: string = this.translateService.instant('modal.esperienzaadmin.export.title');
    let content: string = this.translateService.instant('modal.esperienzaadmin.export.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.wmaiservice.queryAdminStatistics().subscribe(data => {
          if (data != null) {
            if(!this.isMobile){
            this.downloadFile (data, 'statisticheEsperienze');
            } else {
              this.downloadFileMobile (data, 'statisticheEsperienze');
            }
          }
        })
      })
      .onDeny(() => "");
  }
  /**
   * si esportano gli utenti tramite file
   */
  exportUser() {
    let title: string = this.translateService.instant('modal.esperienzaadmin.export.title');
    let content: string = this.translateService.instant('modal.esperienzaadmin.export.content');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.wmaiservice.queryUserStatistics().subscribe(data => {
          if (data != null) {
            if(!this.isMobile){
              this.downloadFile (data, 'statisticheUtenti');
            } else {
              this.downloadFileMobile (data, 'statisticheUtenti');
            }
          }
        })
      })
      .onDeny(() => "");
  }

  predefSearch(search: string) {
    this.searchForm.controls["type"].patchValue(search);
    this.search();
  }

  downloadFile(data, filename) {
    let csvData = this.ConvertToCSV(data, ['Data di creazione della Esperienza', 'Data di ultima modifica della Esperienza', 'Stato della Esperienza', 'Scheda Id', 'Titolo Scheda', 
    'Range eta', 'Genere','Nazione', 'Iscritto Alert', 'Accetto CC', 'Iscritto News', 'Utente Attivo', 'Lingua Usata'
    ]);
    // console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute("download", filename + ".csv");
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
  }

  downloadFileMobile(data, filename) {
    let csvData = this.ConvertToCSV(data, ['Data di creazione della Esperienza', 'Data di ultima modifica della Esperienza', 'Stato della Esperienza', 'Scheda Id', 'Titolo Scheda', 
    'Range eta', 'Genere', 'Iscritto Alert', 'Accetto CC', 'Iscritto News', 'Utente Attivo', 'Lingua Usata'
    ]);
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    var device = this.appService.getDeviceInfo();
    foo.saveBlobToFile(blob, filename, device).then((success) => {
      // let titlec: string = this.translateService.instant('modal.esperienzaadmin.export.title');
      // let contentc: string = this.translateService.instant('modal.esperienzaadmin.export.confirmcontent');
      // this.modalService
      // .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      // .onApprove(() => {
      //   // foo.openFile(success);
      // })
      // .onDeny(() => {
      // });
    }).catch((error) => {
      console.log(error);
    });
  }

  ConvertToCSV(objArray, headerList) {
    let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
    let str = '';
    let row = 'S.No,';
    for (let index in headerList) {
      row += headerList[index] + ',';
    }
    row = row.slice(0, -1);
    str += row + '\r\n';
    for (let i = 0; i < array.length; i++) {
      let line = (i + 1) + '';
      for (let index in headerList) {
        let head = headerList[index];
        line += ',' + array[i][head];
      }
      str += line + '\r\n';
    }
    return str;
  }

}



